import type { Conversation } from "@dtelecom/secure-chat-client"

type ConversationBucket = "contact" | "request" | "hidden"

interface ClassifyContext {
  requestIds: ReadonlySet<string>
  blockedIds: ReadonlySet<string>
}

export function classifyConversation(
  conversation: Conversation,
  ctx: ClassifyContext,
): ConversationBucket {
  // For now show blocked in chat - now on block it is not deleted
  // if (ctx.blockedIds.has(conversation.peerUserId)) return "hidden"
  if (ctx.requestIds.has(conversation.peerUserId)) return "request"
  return "contact"
}
